/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "lambdaApi",
            "endpoint": "https://q97laejip3.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:6e100b12-713f-4d6f-b740-61fa6470d6a3",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_75yhijzbA",
    "aws_user_pools_web_client_id": "1a2idj7djiblh6gsd6c0eh682u",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "neogateway-20220215122719-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dz56d2tnkcam1.cloudfront.net",
    "aws_user_files_s3_bucket": "neogateway-athena-results160559-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
